var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBybit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#15192A",
    fillRule: "evenodd",
    d: "M32 21.99v1.15c0 .32 0 .64-.02.96 0 .7-.07 1.4-.18 2.1a6.72 6.72 0 0 1-5.6 5.6c-.7.11-1.4.17-2.1.18l-.96.02H8.86c-.32 0-.64 0-.96-.02-.7 0-1.4-.07-2.1-.18a6.72 6.72 0 0 1-5.6-5.6c-.11-.7-.17-1.4-.18-2.1L0 23.14V8.86c0-.32 0-.64.02-.96 0-.7.07-1.4.18-2.1A6.72 6.72 0 0 1 5.8.2C6.48.1 7.2.03 7.9.02L8.86 0h14.28c.32 0 .64 0 .96.02.7 0 1.4.07 2.1.18a6.72 6.72 0 0 1 5.6 5.6c.11.69.17 1.4.18 2.1l.02.96V22Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A600",
    d: "M21.67 17.33v-6.55H23v6.55h-1.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.32 19.28H3.5v-6.55h2.71c1.32 0 2.08.71 2.08 1.84 0 .72-.49 1.2-.83 1.35.4.18.93.6.93 1.47 0 1.23-.86 1.89-2.07 1.89Zm-.21-5.41H4.8v1.5h1.3c.55 0 .87-.3.87-.75s-.32-.75-.87-.75Zm.08 2.66H4.82v1.6h1.37c.6 0 .88-.36.88-.8 0-.44-.28-.8-.88-.8Zm6.21.07v2.68h-1.3v-2.69l-2.03-3.86h1.43l1.26 2.64L13 12.73h1.43l-2.02 3.86Zm5.77 2.68h-2.83v-6.55h2.71c1.32 0 2.09.71 2.09 1.84 0 .72-.5 1.2-.83 1.35.4.18.92.6.92 1.47 0 1.23-.86 1.89-2.06 1.89Zm-.22-5.41h-1.29v1.5h1.3c.55 0 .86-.3.86-.75s-.31-.75-.87-.75Zm.09 2.66h-1.38v1.6h1.38c.6 0 .88-.36.88-.8 0-.44-.29-.8-.88-.8Zm9.2-2.66v5.4h-1.32v-5.4h-1.76v-1.14H29v1.14h-1.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBybit);
export default __webpack_public_path__ + "static/media/bybit.ef14310d55dfc8c76cc555ec91c6d13b.svg";
export { ForwardRef as ReactComponent };